import { f as A, r as h, c as k, T as M, s as X } from "../TableHead-CnPS-L9y.es.js";
import e, { useEffect as Y } from "react";
import t from "prop-types";
import D from "lodash";
import S from "classnames";
import $ from "react-resize-observer";
import { w as j } from "../utils-C0l876fA.es.js";
import { d as G, T as W } from "../index-Dd-4N6BE.es.js";
import { B as E } from "../Button-EJIc0kDA.es.js";
import { I as Q } from "../Icon-BuIPTPJn.es.js";
import { T as Z } from "../Tooltip-B-bmRvX4.es.js";
import { B as J, D as K } from "../DataTableShimmer-Lm9Dc2eK.es.js";
import '../index13.css';const V = "Cell-module__colHeader___mXp1B", ee = "Cell-module__rowHeader___R77wO", te = "Cell-module__cell___laxSz", le = "Cell-module__right___d8BNC", oe = "Cell-module__tooltip___Xb8LF", re = "Cell-module__link___v27Xb", ae = "Cell-module__text___QKfF0", ne = "Cell-module__stickyCol___dt3LC", C = {
  "data-table-border-height": "2px",
  "data-table-header-padding": "4px",
  "data-table-row-height": "32px",
  colHeader: V,
  rowHeader: ee,
  cell: te,
  right: le,
  tooltip: oe,
  link: re,
  text: ae,
  stickyCol: ne
}, T = (l) => {
  let a = null, c = "cell";
  l.colHeader ? (a = "col", c = "colHeader") : l.rowHeader && (a = "row", c = "rowHeader");
  const o = {
    className: S(
      C[c],
      l.align === "right" && C.right,
      l.fixedCol && A.fixedCol,
      l.stickyCol && C.stickyCol
    ),
    scope: a,
    tabIndex: 0
  }, n = /* @__PURE__ */ e.createElement("div", { className: S(C.text, G["data-cell"]) }, l.children), { LinkWrapper: i } = l, s = l.onCellClick || l.href ? /* @__PURE__ */ e.createElement(
    i,
    {
      className: C.link,
      href: l.href,
      onClick: (r) => {
        l.href || r.preventDefault(), l.onCellClick && l.onCellClick(r);
      }
    },
    n
  ) : n;
  return l.colHeader || l.rowHeader ? /* @__PURE__ */ e.createElement("th", { ...o }, s) : /* @__PURE__ */ e.createElement("td", { ...o }, s);
};
T.propTypes = {
  align: t.oneOf(["left", "right"]),
  children: t.node.isRequired,
  colHeader: t.bool,
  fixedCol: t.bool,
  // eslint-disable-next-line react/forbid-prop-types
  href: t.any,
  onCellClick: t.func,
  rowHeader: t.bool,
  LinkWrapper: t.elementType,
  stickyCol: t.bool
};
const ie = (l) => /* @__PURE__ */ e.createElement("a", { ...l });
T.defaultProps = {
  align: "left",
  colHeader: !1,
  fixedCol: !1,
  href: null,
  onCellClick: null,
  rowHeader: !1,
  LinkWrapper: ie,
  stickyCol: !1
};
const se = (l) => `${l}`, g = (l) => /* @__PURE__ */ e.createElement("tbody", null, l.data.map((a, c) => (
  // eslint-disable-next-line react/no-array-index-key
  /* @__PURE__ */ e.createElement("tr", { key: c }, l.columns.map((o, n) => {
    const i = o.renderIcon && o.renderIcon(a[o.key]), s = i && typeof i == "object" ? /* @__PURE__ */ e.createElement(Q, { ...i }) : (o.renderCell || se)(a[o.key]), r = o.tooltipContent && o.tooltipContent(a[o.key]);
    return /* @__PURE__ */ e.createElement(
      T,
      {
        key: n,
        align: o.align,
        fixedCol: n === 0,
        rowHeader: l.rowHeader && n === 0,
        onCellClick: o.onCellClick && ((_) => o.onCellClick(a, _)),
        href: o.href && o.href(a),
        LinkWrapper: o.LinkWrapper,
        stickyCol: n === 0 && l.stickFirstColumn
      },
      r && typeof r == "object" && r.content && r.props && (o.renderCell || i) ? /* @__PURE__ */ e.createElement(
        Z.Hover,
        {
          accessible: !0,
          trigger: s,
          ...r.props
        },
        r.content
      ) : s
    );
  }))
)));
g.propTypes = {
  columns: t.arrayOf(k.isRequired).isRequired,
  rowHeader: t.bool.isRequired,
  data: t.arrayOf(h.isRequired).isRequired,
  stickFirstColumn: t.bool
};
g.defaultProps = {
  stickFirstColumn: !1
};
const p = Object.freeze({
  DEFAULT: Symbol("default"),
  LOADING: Symbol("loading"),
  SUCCESS: Symbol("success"),
  ERROR: Symbol("error"),
  RETRY: Symbol("retry")
}), ce = "DataTable-module__table___ZocT8", me = "DataTable-module__scrollWrapper___1txvM", de = "DataTable-module__blurContainer___rueBz", ue = "DataTable-module__paginationSummary___OKUsC", fe = "DataTable-module__summaryWithFootnote___eIMAC", Ce = "DataTable-module__footnote___gzY6C", _e = "DataTable-module__footer___-i8tv", m = {
  table: ce,
  scrollWrapper: me,
  blurContainer: de,
  paginationSummary: ue,
  summaryWithFootnote: fe,
  footnote: Ce,
  footer: _e
}, v = ({
  buttonText: l,
  buttonStatus: a,
  initialLoadStatus: c,
  sortStatus: o,
  columns: n,
  data: i,
  footnote: s,
  loadMore: r,
  totalCount: _,
  rowHeader: L,
  sortBy: R,
  sortColumn: w,
  sortDirection: H,
  stickyHeader: O,
  t: u
}) => {
  const [b, N] = e.useState(!1), [P, q] = e.useState(!1), d = e.createRef(), y = () => {
    N(
      D.get(d.current, "scrollWidth") > D.get(d.current, "clientWidth")
    );
  };
  Y(y, [y]);
  const B = {
    "view all": u("view all"),
    "load more": u("load more"),
    "view more": u("view more")
  }, U = () => {
    q((f) => {
      const x = d.current.scrollWidth - d.current.scrollLeft - d.current.clientWidth < 1;
      return f !== x ? { newScrolledRight: x } : {};
    });
  }, I = (f) => {
    f === w ? R(f, H === "asc" ? "desc" : "asc") : R(f, "asc");
  }, z = s ? m.summaryWithFootnote : m.paginationSummary;
  return /* @__PURE__ */ e.createElement("div", { "aria-live": "polite", "data-testid": "data-table-parent" }, /* @__PURE__ */ e.createElement($, { onResize: y }), c === p.SUCCESS ? /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
    "div",
    {
      className: S({
        [m.scrollWrapper]: b
      }),
      ref: d,
      onScroll: U
    },
    b && !P && /* @__PURE__ */ e.createElement("div", { className: m.blurContainer }),
    /* @__PURE__ */ e.createElement("table", { className: m.table, "aria-live": "polite" }, /* @__PURE__ */ e.createElement(
      M,
      {
        columns: n,
        stickFirstColumn: b,
        sortBy: I,
        sortColumn: w,
        sortDirection: H,
        stickyHeader: O
      }
    ), o !== p.SUCCESS ? /* @__PURE__ */ e.createElement(J, { numCols: 6, numRows: 10 }) : /* @__PURE__ */ e.createElement(
      g,
      {
        columns: n,
        data: i,
        rowHeader: L,
        stickFirstColumn: b
      }
    )),
    r && /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
      E.MutedButton,
      {
        status: a,
        handleClick: r,
        disabled: i.length === _,
        fullWidth: !0
      },
      B[l]
    ))
  ), /* @__PURE__ */ e.createElement("div", { className: m.footer }, s && /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement("div", { className: m.footnote }, /* @__PURE__ */ e.createElement(W.DataPagination, { responsive: !0 }, s))), /* @__PURE__ */ e.createElement("div", { className: z }, /* @__PURE__ */ e.createElement(W.DataPagination, { responsive: !0 }, u("dataTableRows", {
    rows: i.length,
    total: _
  }))))) : /* @__PURE__ */ e.createElement("div", { "aria-label": u("loading") }, /* @__PURE__ */ e.createElement(K, { numCols: 6, numRows: 10 })));
};
v.propTypes = {
  /** The text on the big button to load more data in the modal. */
  buttonText: t.oneOf(["view more", "load more", "view all"]),
  /** Status of the button, supports predefined status(DEFAULT, LOADING, SUCCESS, ERROR, RETRY) from Button.Status */
  buttonStatus: t.oneOf(Object.values(E.Status)),
  /** Data representing the labels of the tables of the columns and how to render a generic cell within the column. */
  columns: t.arrayOf(k.isRequired).isRequired,
  /** The data in the table. Array index corresponds to the row in the table, and the key-value pairs in each entry correspond to the data appearing in the columns of the row. This prop should be JSON-serialisable. */
  data: t.arrayOf(h.isRequired).isRequired,
  /** a message to be displayed beneath the footer */
  footnote: t.string,
  /** Status of the initial datatable load, supports status(DEFAULT, LOADING, SUCCESS, ERROR, RETRY). May need updated once async actions are supported for DataTables */
  initialLoadStatus: t.symbol,
  /** Gets called upon clicking the 'view more' button, and determines if the button will show in the table. */
  loadMore: t.func,
  /** The total rows of data (number of results) that can possibly be loaded into the table. */
  totalCount: t.number.isRequired,
  /** Renders the first column of the table as a header when true (with a ruling on the right-hand-side and accessibility data). */
  rowHeader: t.bool,
  /** Gets called on clicking on a sortable column header cell. It will pass the column key of the column clicked on, and the new sort direction, and should update the sortColumn and sortDirection prop values. */
  sortBy: t.func,
  /** Sort table by this column's values descending. */
  sortColumn: t.string,
  /** The direction of the sorting on the current sortColumn. */
  sortDirection: X,
  /** Status of async sorting on the DataTable, supports status(DEFAULT, LOADING, SUCCESS, ERROR, RETRY). May need updated once async actions are supported for DataTables */
  sortStatus: t.symbol,
  /** Renders the header, if there is one, as a fixed sticky header that persists on scroll */
  stickyHeader: t.bool,
  /** MRUI's translate function, (automatically added to the component) */
  t: t.func.isRequired
};
v.defaultProps = {
  buttonStatus: E.Status.DEFAULT,
  buttonText: "view more",
  footnote: null,
  initialLoadStatus: p.SUCCESS,
  loadMore: void 0,
  rowHeader: !1,
  sortBy: () => {
  },
  sortColumn: void 0,
  sortDirection: void 0,
  sortStatus: p.SUCCESS,
  stickyHeader: !0
};
const F = j(v);
F.columnPropType = k;
F.rowPropType = h;
export {
  F as default
};
